import axiosInstance from 'api/axiosInstance';
import { CANtrackCommentRaw } from 'api/comments/getComments';

async function getCommentsByCaseId(caseId: number): Promise<CANtrackCommentRaw[]> {
	const payload = {
		CaseId: caseId,
		Take: 100,
	};
	const data = await axiosInstance.get(
		`/api/cantrackv3/ReadComments?payload=${JSON.stringify(payload)}`,
	);
	if (!data || !data.data.Data)
		throw new Error('Failed to fetch comments for case');
	return data.data.Data;
}

export default getCommentsByCaseId;
